export function generateNumbers({ range, length, startAt = 1 }: { range?: { start: number; end: number; step?: number }, length?: number, startAt?: number }): number[] {
  if (range) {
    const { start, end, step = 1 } = range;
    return Array.from(
      { length: Math.floor((end - start) / step) + 1 },
      (_, i) => start + i * step
    );
  }

  if (!length) return [];

  return Array.from({ length }, (_, i) => startAt + i);
}